import store, { useRecoilValue } from '@store';

export const useSelectedOptionIsAvailable = () => {
  return (queriedOption) =>
    useRecoilValue(store.optionIsAvailable$(queriedOption));
};
